import style from './css'

const styledSinglePageFlow = {
  label: 'Demo - Gambling Listbox CSS Styled',
  includeInShowcase: true,
  config: {
    userId: 'PayTestGB',
    merchantId: 198003,
    tabs: true,
    singlePageFlow: true,
    showHeader: false,
    logoFullWidth: true
  },
  theme: {
    input: {
      height: '52px'
    },
    buttons: {
      color: '#000000'
    },
    labels: {
      color: '#7d7d7d'
    },
    background: {
      color: '#fafbfc'
    },
    loader: {
      color: '#000000'
    }
  },
  style
}

export default styledSinglePageFlow
